<template>
  <div>
    <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="提供日期" prop="weekdate">
            <el-date-picker v-fixZoom v-if="addEditObj.isAdd" value-format="yyyy-MM-dd" style="width:100%;" v-model="addEditForm.weekdate" type="date" placeholder="选择日期" :clearable="false" @change="getWeekday"></el-date-picker>
            <span v-else>{{addEditForm.weekdate}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提供星期" prop="" v-if="addEditForm.weekdate !== ''">
            <span>{{addEditForm.week}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="提供类型" prop="type">
            <el-select v-fixZoom v-if="addEditObj.isAdd" v-model="addEditForm.type" filterable placeholder="请选择" :clearable="true" style="width:100%;" >
              <el-option v-for="item in typeArr" :key="item.index" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span v-else>
              <span v-if="addEditForm.type === 1">早餐</span>
              <span v-if="addEditForm.type === 2">午餐</span>
              <span v-if="addEditForm.type === 4">晚餐</span>
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属餐厅" prop="restaurantid">
            <el-select v-fixZoom v-if="addEditObj.isAdd" :disabled="!addEditObj.isAdd" v-model="addEditForm.restaurantid" filterable placeholder="请选择" :clearable="true" style="width:100%;" @change="changeRestaurant">
              <el-option v-for="item in restaurants" :key="item.index" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span v-else>{{getRestaurantName(addEditForm.restaurantid)}}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="菜品" prop="dishcnts"><span style="font-size: 12px;color: #999999">请选择餐厅菜品</span></el-form-item>
      <div style="margin: -20px 0 0 20px;overflow-y: auto">
        <el-table key="key0" style="border:1px solid #cccccc" height="240px" row-key="id" ref="multiple0" tooltip-effect="dark" size="mini" border :data="selectIngredientArr" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"/>
          <el-table-column label="菜品名称" align="center" prop="name"/>
          <el-table-column
            label="卡路里"
            width="70"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.dish_kcal !== ''">{{scope.row.dish_kcal}} kcal</span>
            </template>
          </el-table-column>
          <el-table-column label="营养成分">
            <template slot-scope="scope">
              <div v-if="scope.row.nutrients !== ''">
                <span>碳水化合物:{{scope.row.nutrients.CHO}}克</span><br>
                <span>蛋白质:{{scope.row.nutrients.PRO}}克</span><br>
                <span>脂肪:{{scope.row.nutrients.FAT}}克</span><br>
                <span>糖类:{{scope.row.nutrients.SUG}}克</span><br>
                <span>膳食纤维:{{scope.row.nutrients.DF}}克</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数量" :key="'dish0'">
            <template slot-scope="scope">
              <input style="width: 99%;height: 26px;border: 1px solid #cccccc" type="number" v-model="scope.row.cnt" placeholder="请输入数量"/>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-form-item label="套餐" prop="dishcnts"><span style="font-size: 12px;color: #999999">请选择餐厅套餐</span></el-form-item>
      <div style="margin: -20px 0 0 20px;overflow-y: auto">
        <el-table key="key1" style="border:1px solid #cccccc" height="240px" ref="multiple1" tooltip-effect="dark" size="mini" border :data="selectDishpackages" @selection-change="handleSelectionChange1">
          <el-table-column type="selection" width="55" align="center"/>
          <el-table-column label="套餐名称" align="center" prop="name"/>
          <el-table-column
            label="总卡路里"
            width="80"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.kcal !== ''">{{scope.row.kcal}} kcal</span>
            </template>
          </el-table-column>
          <el-table-column
            label="菜品"
            min-width="140"
            align="center">
            <template slot-scope="scope">
              <table border="1" style="border-collapse: collapse;border: #d3d4d5;margin: auto" v-if="scope.row.dishcnts.length !== 0">
                <tr v-for="tag in scope.row.dishcnts" :key="tag.id">
                  <td style="padding: 5px 15px">{{tag.name}} / {{tag.cnt}}份</td>
                  <td style="padding: 5px 15px" v-if="tag.nutrients !== ''">
                    <div>
                      <span>碳水化合物:{{tag.nutrients.CHO}}克</span><br>
                      <span>蛋白质:{{tag.nutrients.PRO}}克</span><br>
                      <span>脂肪:{{tag.nutrients.FAT}}克</span><br>
                      <span>糖类:{{tag.nutrients.SUG}}克</span><br>
                      <span>膳食纤维:{{tag.nutrients.DF}}克</span>
                    </div>
                  </td>
                </tr>
              </table>
            </template>
          </el-table-column>
          <el-table-column label="数量" :key="'dish1'">
            <template slot-scope="scope">
              <input style="width: 99%;height: 26px;border: 1px solid #cccccc" type="number" v-model="scope.row.cnt" placeholder="请输入数量"/>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <div style="height: 50px;margin-top: 10px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()"><span>取消</span></div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')"><span>确定</span></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {adddishweek, updatedishweek} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditWeekMenu',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      restaurants: [], // 餐厅
      dishes: [], // 菜品
      dishpackages: [], // 套餐
      selectDishes: [],
      typeArr: [
        {id: 1, name: '早餐'},
        {id: 2, name: '午餐'},
        {id: 4, name: '晚餐'}
      ],
      weeks: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      addEditForm: {
        id: '',
        week: '',
        weekdate: '',
        restaurantid: '',
        type: '',
        eid: '',
        dishcnts: [],
        CHO: '',
        PRO: '',
        FAT: '',
        DF: '',
        SUG: '',
        dish_kcal: 0,
        dish_type: 1
      },
      addEditRules: {
        weekdate: [
          {required: true, message: '请选择日期', trigger: 'change'}
        ],
        restaurantid: [
          {required: true, message: '请选择餐厅', trigger: 'change'}
        ],
        type: [
          {required: true, message: '请选择提供类型', trigger: 'change'}
        ],
        types: [
          {required: true, message: '请选择提供类型', trigger: 'change'}
        ]
        // dishcnts: [
        //   {required: true, message: '请选择菜品', trigger: 'change'}
        // ]
      },
      selectIngredientArr: [], // 菜品table
      dishcnts0: [], // 所选择的菜品
      selectDishpackages: [], // 套餐table
      dishcnts1: [] // 所选择的套餐
    }
  },
  created () {
    this.restaurants = this.addEditObj.restaurants
    this.dishes = this.addEditObj.dishes
    this.dishpackages = this.addEditObj.dishpackages
    if (this.addEditObj.isAdd) {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
    } else {
      let row = this.clone(this.addEditObj.row)
      // let nutrients = row.nutrients
      this.addEditForm = {
        id: row.id,
        week: row.week,
        weekdate: (row.weekdate !== '' && row.weekdate !== '0000-00-00') ? row.weekdate : '',
        restaurantid: row.restaurantid,
        type: row.type,
        eid: row.eid
      }
    }
  },
  mounted () {
    if (!this.addEditObj.isAdd) {
      // debugger
      console.log(this.addEditObj)
      this.changeRestaurant(this.addEditObj.row.restaurantid)
    }
  },
  methods: {
    handleSelectionChange (selection) {
      // console.log(99, selection)
      this.dishcnts0 = selection
    },
    handleSelectionChange1 (selection) {
      // console.log(99, selection)
      this.dishcnts1 = selection
    },
    getWeekday (dateStr) {
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const date = new Date(dateStr)
      const weekday = date.getDay()
      // console.log(weekDays[weekday])
      this.addEditForm.week = weekDays[weekday]
    },
    getRestaurantName (id) {
      let name = id
      for (let i = 0; i < this.restaurants.length; i++) {
        if (id === this.restaurants[i].id) {
          name = this.restaurants[i].name
        }
      }
      return name
    },
    changeRestaurant (id) {
      let arr = []
      for (let i = 0; i < this.dishes.length; i++) {
        if (id === this.dishes[i].restaurantid) {
          let obj = this.dishes[i]
          obj.desc = ''
          obj.cnt = '1'
          arr.push(obj)
        }
      }
      this.selectDishes = arr
      this.selectIngredientArr = arr
      let arr1 = []
      this.dishpackages.forEach(item => {
        item.desc = ''
        item.cnt = '1'
        arr1.push(item)
      })
      this.selectDishpackages = arr1
      if (!this.addEditObj.isAdd) {
        this.getSelecArr()
      }
    },
    getSelecArr () {
      let list = []
      for (let i = 0; i < this.selectIngredientArr.length; i++) {
        let item = this.selectIngredientArr[i]
        this.addEditObj.row.endArr0.forEach((val, index) => {
          if (val.id === item.id) {
            this.selectIngredientArr[i].cnt = val.cnt
            item.desc = val.desc
            item.cnt = val.cnt
            list.push(item)
          }
        })
      }
      setTimeout(() => {
        list.forEach((row) => {
          this.$refs.multiple0.toggleRowSelection(row)
        })
      }, 300)
      let list1 = []
      for (let i = 0; i < this.selectDishpackages.length; i++) {
        let item1 = this.selectDishpackages[i]
        this.addEditObj.row.endArr1.forEach(val => {
          if (val.dishpackageid === item1.id) {
            this.selectDishpackages[i].cnt = val.cnt
            item1.desc = val.desc
            item1.cnt = val.cnt
            list1.push(item1)
          }
        })
      }
      setTimeout(() => {
        list1.forEach((row) => {
          this.$refs.multiple1.toggleRowSelection(row, true)
        })
      }, 300)
      this.dishcnts0 = list
      this.dishcnts1 = list1
      console.log(1, this.dishcnts0)
      console.log(2, this.dishcnts1)
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      console.log(this.dishcnts0)
      console.log(this.dishcnts1)
      let dishcnts = []
      this.dishcnts0.forEach(dish => {
        let obj = {
          id: dish.id,
          cnt: parseInt(dish.cnt),
          desc: dish.desc,
          dishpackageid: 0,
          dishpackagename: ''
        }
        dishcnts.push(obj)
      })
      this.dishcnts1.forEach(dish => {
        // console.log(88, dish.cnt, dish.dishcnts)
        dish.dishcnts.forEach(item => {
          let obj = {
            id: item.id,
            cnt: parseInt(dish.cnt),
            desc: dish.desc,
            dishpackageid: dish.id,
            dishpackagename: dish.name
          }
          // console.log(1, obj)
          dishcnts.push(obj)
        })
      })
      console.log(dishcnts)
      // return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (dishcnts.length === 0) {
            this.$message({ message: '请选择菜品或套餐。', type: 'warning' })
            return
          }
          // let nutrients = {
          //   CHO: this.addEditForm.CHO,
          //   PRO: this.addEditForm.PRO,
          //   FAT: this.addEditForm.FAT,
          //   DF: this.addEditForm.DF,
          //   SUG: this.addEditForm.SUG
          // }
          if (this.addEditObj.isAdd) {
            // let dishcnts = []
            // for (let i = 0; i < this.addEditForm.dishcnts.length; i++) {
            //   let obj = {
            //     id: this.addEditForm.dishcnts[i].id,
            //     cnt: parseInt(this.addEditForm.dishcnts[i].cnt),
            //     desc: this.addEditForm.dishcnts[i].desc
            //   }
            //   dishcnts.push(obj)
            // }
            let data = {
              week: this.addEditForm.week,
              weekdate: this.addEditForm.weekdate,
              restaurantid: this.addEditForm.restaurantid,
              eid: this.addEditForm.eid,
              type: parseInt(this.addEditForm.type),
              dishcnts: dishcnts,
              // dish_nutrients: JSON.stringify(nutrients),
              dish_type: this.addEditForm.dish_type
              // dish_kcal: this.addEditForm.dish_kcal + ''
            }
            adddishweek(data).then(res => {
              if (res.data.dishweek.id !== 0) {
                this.$notify({title: '成功', message: '成功新增供应菜单', type: 'success', duration: 2000})
                this.$emit('updateTable')
              } else {
                this.$message({ message: '已录入有日期。', type: 'warning' })
              }
              this.$emit('change', false)
            })
          } else {
            // let dishcnts = []
            // for (let i = 0; i < this.addEditForm.dishcnts.length; i++) {
            //   let obj = {
            //     id: this.addEditForm.dishcnts[i].id,
            //     cnt: parseInt(this.addEditForm.dishcnts[i].cnt),
            //     desc: this.addEditForm.dishcnts[i].desc
            //   }
            //   dishcnts.push(obj)
            // }
            let data = {
              id: this.addEditForm.id,
              week: this.addEditForm.week,
              weekdate: this.addEditForm.weekdate,
              restaurantid: this.addEditForm.restaurantid,
              eid: this.addEditForm.eid,
              type: parseInt(this.addEditForm.type),
              dishcnts: dishcnts,
              // dish_nutrients: JSON.stringify(nutrients),
              dish_type: this.addEditForm.dish_type
              // dish_kcal: this.addEditForm.dish_kcal + ''
            }
            updatedishweek(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑供应菜单', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditWeekMenu.vue